import { useEffect, useRef } from 'react'
import { heartbeat } from './livestreamApi'
import { isPageVisible } from './usePageVisible'

// intervalSec 0 = backend ไม่ได้ส่ง heartbeat_sec มา → ไม่ส่ง
// response มี `stream` เฉพาะตอนที่ URL เปลี่ยน (token หมุน)
export default function useHeartbeat(sessionId, intervalSec, handlers) {
  const saved = useRef(handlers)
  saved.current = handlers

  useEffect(() => {
    if (!sessionId || !intervalSec) return undefined

    let cancelled = false
    const beat = () => {
      heartbeat(sessionId)
        .then(res => {
          if (!cancelled && saved.current.onTick) saved.current.onTick(res)
        })
        .catch(err => {
          if (!cancelled && saved.current.onFail) saved.current.onFail(err)
        })
    }
    const timer = setInterval(beat, intervalSec * 1000)

    // แท็บที่ถูกซ่อนนาน ๆ heartbeat ถูกหน่วงจน backend ตัดผู้ชมทิ้งได้ — กลับมาแสดงแล้วส่งทันที
    // จะได้รู้เร็วว่า session ยังอยู่ไหม แทนการรอรอบถัดไป
    const onVisible = () => {
      if (isPageVisible()) beat()
    }
    document.addEventListener('visibilitychange', onVisible)

    return () => {
      cancelled = true
      clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [sessionId, intervalSec])
}
